import {Card, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";

export const FilteredContentWarning = () => {
    const {t} = useTranslation();
    return (
        <Card
            fz="sm"
            ff="text"
            shadow="sm"
            padding="md"
            style={{backgroundColor: "var(--mantine-color-gray-0)"}}
        >
            <Text style={{whiteSpace: "pre-wrap"}}>
                {t("error.filteredContent.body")}
            </Text>
        </Card>
    );
};
